import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { IRideInvestigationHistoryDto } from "@ryde/shared";

import { INVESTIGATION_HISTORY } from "../investigation.constants";

interface IInvestigationHistoryNoticesProps {
  history?: IRideInvestigationHistoryDto;
  isLoading: boolean;
  hasError: boolean;
}

/** What the list does not show, and why: still loading, failed, capped or not linkable to a ride. */
export const InvestigationHistoryNotices: FC<
  IInvestigationHistoryNoticesProps
> = ({ history, isLoading, hasError }) => {
  const { t } = useTranslation();
  const key = INVESTIGATION_HISTORY.i18nKey;
  const sourceNames = (sources: string[]): string =>
    sources.map(source => t(`${key}.source.${source}`)).join(", ");

  return (
    <div className="history-notices" role="status" aria-live="polite">
      {isLoading && <span>{t(`${key}.loading`)}</span>}
      {hasError && (
        <span className="history-notice--warning">{t(`${key}.error`)}</span>
      )}
      {!!history?.unavailableSources.length && (
        <span className="history-notice--warning">
          {t(`${key}.unavailable`, {
            sources: sourceNames(history.unavailableSources),
          })}
        </span>
      )}
      {!!history?.limitedSources.length && (
        <span>
          {t(`${key}.limited`, {
            sources: sourceNames(history.limitedSources),
          })}
        </span>
      )}
      {history && <span>{t(`${key}.messagesNotLinked`)}</span>}
    </div>
  );
};
